import React from "react";

function AuthenticFlavorBanner() {
  return (
    <section
      className="w-full py-8 sm:py-12 text-center"
      style={{ backgroundColor: "#5786ff" }}
    >
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-8"
          style={{
            fontFamily: "'Signika Negative', sans-serif",
          }}
        >
          Authentic Haitian Flavor. No Compromises.
        </h2>

        <div className="max-w-3xl mx-auto">
          <p className="text-base sm:text-lg text-white leading-relaxed mb-6">
            We proudly serve 100% authentic Haitian cuisine
            prepared the traditional way—with real ingredients,
            bold spices, and techniques that honor our culture.
            No shortcuts. Just real Haitian food, done right.
          </p>

          <p className="text-base sm:text-lg text-white leading-relaxed">
            Whether you grew up with these dishes or you're
            discovering them for the first time, you'll taste the
            difference. Many guests keep coming back, telling us
            it's some of the most flavorful food they've ever
            had.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AuthenticFlavorBanner;
